import React, { Fragment } from 'react';

// store = SaleWizardStore
export default ({ store, t }) => (
  <Fragment>
    <div>
      {store.source.item.number}: {store.source.item.title}
    </div>
    <div>
      {t(`salepropertytype::${store.source.saleEdit.offerData.object_type}`)},{' '}
      {store.source.saleEdit.offerData.object_address}
    </div>
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Duplicate/SaleInfo.jsx